import React from 'react';
import {DatePicker} from '@unthinkable/react-date-picker';
import {useStyles} from '@unthinkable/react-theme';
import {DateInputStyles} from './theme';

export const DateInput = props => {
  let styles = useStyles(DateInputStyles);
  return <DatePicker {...props} styles={styles} />;
};
